var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "option-switch" }, [
    _c(
      "div",
      { staticClass: "os-label" },
      [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.config.longLabel ? _vm.config.longLabel : _vm.config.label
            ),
          },
        }),
        _vm._v(" "),
        _vm.config.supplementary
          ? [
              _c("small", {
                staticClass: "supplementary",
                domProps: { innerHTML: _vm._s(_vm.config.supplementary) },
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("label", { staticClass: "switch mb-0" }, [
      _c("input", {
        staticClass: "checkbox",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.value },
        on: {
          change: function ($event) {
            return _vm.didChangeSwitch($event)
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "runner" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }